import React from 'react';
import { Calculator, Clock, Coffee } from 'lucide-react';

/**
 * Компонент для настройки предпочтений потребления воды
 */
const IntakePreferencesSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-cyan-50 dark:bg-cyan-900/20 p-4 rounded-lg border border-cyan-200 dark:border-cyan-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Calculator className="w-5 h-5 mr-2 text-cyan-500" />
        Настройки потребления воды
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Размер емкости */}
        <div>
          <label htmlFor="preferredContainerSize" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Объем вашей обычной емкости (мл)
          </label>
          <input
            type="text"
            id="preferredContainerSize"
            name="waterIntakePreferences.preferredContainerSize"
            value={formData.waterIntakePreferences.preferredContainerSize}
            onChange={handleInputChange}
            className={`form-input w-full ${errors['waterIntakePreferences.preferredContainerSize'] ? 'input-error' : ''}`}
            placeholder="Например, 250 (стакан) или 500 (бутылка)"
          />
          {errors['waterIntakePreferences.preferredContainerSize'] && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors['waterIntakePreferences.preferredContainerSize']}
            </p>
          )}
        </div>

        {/* Время пробуждения */}
        <div>
          <label htmlFor="wakeUpTime" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Clock className="w-4 h-4 mr-2 text-cyan-500" />
            Время пробуждения
          </label>
          <input
            type="time"
            id="wakeUpTime"
            name="waterIntakePreferences.wakeUpTime"
            value={formData.waterIntakePreferences.wakeUpTime}
            onChange={handleInputChange}
            className={`form-input w-full ${errors['waterIntakePreferences.wakeUpTime'] ? 'input-error' : ''}`}
          />
          {errors['waterIntakePreferences.wakeUpTime'] && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors['waterIntakePreferences.wakeUpTime']}
            </p>
          )}
        </div>

        {/* Время отхода ко сну */}
        <div>
          <label htmlFor="bedTime" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Clock className="w-4 h-4 mr-2 text-cyan-500" />
            Время отхода ко сну
          </label>
          <input
            type="time"
            id="bedTime"
            name="waterIntakePreferences.bedTime"
            value={formData.waterIntakePreferences.bedTime}
            onChange={handleInputChange}
            className={`form-input w-full ${errors['waterIntakePreferences.bedTime'] ? 'input-error' : ''}`}
          />
          {errors['waterIntakePreferences.bedTime'] && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors['waterIntakePreferences.bedTime']}
            </p>
          )}
        </div>

        {/* Дополнительные параметры */}
        <div className="col-span-full">
          <div className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Дополнительные настройки:
          </div>
          <div className="space-y-2">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                name="waterIntakePreferences.includesFoodWater"
                checked={formData.waterIntakePreferences.includesFoodWater}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Учитывать воду, получаемую из пищи (~20% общей потребности)
              </span>
            </label>
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                name="waterIntakePreferences.includesOtherBeverages"
                checked={formData.waterIntakePreferences.includesOtherBeverages}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Учитывать другие напитки (чай, соки, компоты и т.д.)
              </span>
            </label>
          </div>
        </div>
      </div>

      <div className="mt-4 bg-cyan-100 dark:bg-cyan-900/30 p-3 rounded-lg border border-cyan-200 dark:border-cyan-800">
        <div className="flex items-start">
          <Coffee className="w-5 h-5 text-cyan-600 dark:text-cyan-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-cyan-700 dark:text-cyan-300 mb-1">
              Напитки и гидратация
            </h4>
            <p className="text-xs text-cyan-600 dark:text-cyan-400">
              Помните, что хотя чай, кофе и соки могут вносить вклад в общее потребление жидкости, 
              они не могут полностью заменить чистую воду. Кофеинсодержащие напитки (кофе, крепкий чай) 
              обладают мочегонным эффектом. Диетологи рекомендуют, чтобы не менее 50-60% суточной 
              потребности в жидкости обеспечивалось чистой водой.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntakePreferencesSection;